import React from 'react';

/**
 * Pill input matching the new chunky Divispend design.
 * Thick white border, rounded-full, transparent background, green focus.
 */
export const PillInput = React.forwardRef(({ className = '', error, ...props }, ref) => (
  <input
    ref={ref}
    className={`w-full bg-transparent border-[3px] ${error ? 'border-red-500' : 'border-white focus:border-[#22C55E]'} rounded-full px-6 py-4 text-white text-base sm:text-lg placeholder:text-white/40 focus:outline-none transition-colors disabled:opacity-50 ${className}`}
    {...props}
  />
));
PillInput.displayName = 'PillInput';

/**
 * Pill button — outlined green by default, can be inverted for primary white-bg.
 */
export function PillButton({ children, variant = 'outline', className = '', type = 'submit', ...props }) {
  const styles = variant === 'solid'
    ? 'bg-[#22C55E] text-black hover:bg-[#16A34A] border-[3px] border-[#22C55E]'
    : variant === 'white'
      ? 'border-[3px] border-white text-white active:bg-white/10'
      : 'border-[3px] border-[#22C55E] text-[#22C55E] active:bg-[#22C55E]/10';
  return (
    <button
      type={type}
      className={`w-full rounded-full px-6 py-4 text-base sm:text-lg font-bold tracking-tight transition-colors disabled:opacity-50 ${styles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

/**
 * Section row — used for grouped settings items.
 */
export function PillRow({ icon: Icon, label, value, onClick, to, testId }) {
  const Wrapper = to ? require('react-router-dom').Link : 'button';
  const wrapperProps = to ? { to } : { type: 'button', onClick };
  return (
    <Wrapper
      {...wrapperProps}
      data-testid={testId}
      className="w-full bg-black border-[3px] border-white rounded-[18px] px-4 py-3 flex items-center gap-3 active:scale-[0.98] transition-transform text-left"
    >
      {Icon && (
        <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5 text-[#22C55E]" weight="fill" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-bold tracking-tight truncate">{label}</p>
        {value && <p className="text-white/50 text-xs truncate">{value}</p>}
      </div>
      <span className="text-white/30 text-xl leading-none">›</span>
    </Wrapper>
  );
}
